
import { Component, Prop, Vue } from 'vue-property-decorator'
import ModalV2 from '@/components/confirmModal/index.vue'

import fab from './views/fab.vue'
@Component({
  components: { fab, ModalV2 }
})
export default class extends Vue {}
